import { Box } from 'components/Box/Box';
import { Hide } from 'components/Hide/Hide';
import { StyledVersionedRouterLink } from 'components/Link/StyledVersionedRouterLink';
import type { SearchContextHeaderData } from 'modules/search/containers/SearchContextHeader/SearchContextHeaderData';

type SidebarLinksProps = {
  orgUrl: string | null;
  searchContext: SearchContextHeaderData | null | undefined;
};

export function ListingViewSidebarLinks({
  orgUrl,
  searchContext,
}: SidebarLinksProps) {
  return (
    <Hide xs sm md>
      <Box display="flex" gridGap={3} flexDirection="column">
        {searchContext && (
          <StyledVersionedRouterLink
            to={searchContext.searchResultsUrl}
            state={searchContext.searchResultsState}
            data-qa-id="search-context-back-to-search-sidebar"
          >
            {getText('Back to search results')}
          </StyledVersionedRouterLink>
        )}

        {orgUrl && (
          <>
            <StyledVersionedRouterLink to={`${orgUrl}#opportunities`}>
              {getText('See all listings from this organization')}
            </StyledVersionedRouterLink>
            <StyledVersionedRouterLink to={`${orgUrl}#about`}>
              {getText('About this organization')}
            </StyledVersionedRouterLink>
          </>
        )}
      </Box>
    </Hide>
  );
}
